import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PassService } from '../../../services/pass.service';
import { PassesResponse } from '../../../models/passes-response.model';
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Component({
  selector: 'app-house-flat-pases-page',
  templateUrl: './house-flat-pases-page.component.html',
  styleUrl: './house-flat-pases-page.component.scss'
})
export class HouseFlatPasesPageComponent {

  private neighborhoodId: string = '';
  private streetBuildingId: string = '';
  private houseFlatId: string = '';

  public passesResponse: PassesResponse = new PassesResponse({
    canceled: [],
    declined: [],
    overdue: [],
    active: [],
    history: []
  });

  public hoveredDate: NgbDate | null = null;
  public fromDate: NgbDate | null;
  public toDate: NgbDate | null;
  private readonly maxDays = 31;

  constructor(
    private activedRoute: ActivatedRoute,
    private passService: PassService,
    public formatter: NgbDateParserFormatter,
    private calendar: NgbCalendar,
  ) {

    this.toDate = this.calendar.getToday();
    this.fromDate = this.calendar.getPrev(this.toDate, 'd', this.maxDays);

    this.activedRoute.params.subscribe(params => {
      console.log(params);

      this.neighborhoodId = params['neighborhoodId'];
      this.streetBuildingId = params['streetBuildingId'];
      this.houseFlatId = params['houseFlatId'];

      this.getData();

    });

  }

  async getData() {

    this.passesResponse = await this.passService.getByHouseFlat(
      this.neighborhoodId,
      this.streetBuildingId,
      this.houseFlatId,
      this.toIsoString(this.fromDate!),
      this.toIsoString(this.toDate!)
    );

    console.log(this.passesResponse);

  }

  // region isHovered
  isHovered(date: NgbDate): boolean {
    if (!this.fromDate || this.toDate || !this.hoveredDate) return false;
    return date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  // region isInside
  isInside(date: NgbDate): boolean {
    return this.toDate != null && date.after(this.fromDate) && date.before(this.toDate);
  }

  // region isRange
  isRange(date: NgbDate): boolean {
    return (
      date.equals(this.fromDate) ||
      (this.toDate != null && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  // region onDateSelection
  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      const maxTo = this.calendar.getNext(this.fromDate, 'd', this.maxDays);
      this.toDate = date.after(maxTo) ? maxTo : date;
      this.getData();
    } else {
      this.toDate = null!;
      this.fromDate = date;
    }
  }

  // region toIsoString
  toIsoString(date: NgbDate): string {
    return moment({ year: date.year, month: date.month - 1, day: date.day }).format('YYYY-MM-DD');
  }

  // region validateInput
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed))
      ? NgbDate.from(parsed)
      : currentValue;
  }

  // region getKeys
  getKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  // region getTitle
  getTitle(key: string): string {
    let title = '';

    switch (key) {
      case 'canceled':
        title = 'Cancelados';
        break;
      case 'declined':
        title = 'Rechazados';
        break;
      case 'overdue':
        title = 'Vencidos';
        break;
      case 'active':
        title = 'Activos';
        break;
      case 'history':
        title = 'Historial';
        break;
      default:
        title = key;
        break;
    }

    return title;
  }

}
